<template>
    <span>
        <span class="tag is-medium is-danger" v-if="status === 'Late'">Late</span>
        <span class="tag is-medium is-success" v-if="status === 'Delivered'">Complete</span>
        <span class="tag is-medium is-danger" v-if="status === 'Canceled'">Canceled</span>
        <span class="tag is-medium is-primary" v-if="status === 'In Progress'">In Progress</span>
        <span class="tag is-medium is-primary" v-if="status === 'Pending'">Pending</span>
    </span>
</template>
<script>
    export default {
        name: 'TaskStatus',
        props: {
            status: {
                type: String,
                required: true
            }
        }
    }
</script>